import React, { useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { BsTrash, BsDownload, BsEnvelope, BsCloudUpload, BsCheckCircle, BsArrowRepeat } from "react-icons/bs";
import { ActionButton } from '../../widgets/DataTable';
import './nomina.css';

const ActionButtons = ({ 
  currentData, 
  onEnviarPayroll, 
  onConfirmPayroll, 
  onGetPDF, 
  onMailerDoc, 
  onDeleteDoc,
  onReprocess
}) => {
  // Acción en curso en esta fila: muestra el spinner en su botón y bloquea las demás
  const [enCurso, setEnCurso] = useState(null);
  const estado = currentData.DOCUMENTO_ENVIADO;
  const acciones = [
    { tip: "Cargar Documento", clase: "enviar", icon: <BsCloudUpload />, onClick: onEnviarPayroll,
      disabled: !(estado === "0" || estado === "5") || currentData.VALID !== 0 },
    { tip: "Confirmar Estado", clase: "confirmar", icon: <BsCheckCircle />, onClick: onConfirmPayroll,
      disabled: !(estado === "1") },
    { tip: "Descargar PDF", clase: "pdf", icon: <BsDownload />, onClick: onGetPDF, disabled: false },
    { tip: "Enviar Email", clase: "correo", icon: <BsEnvelope />, onClick: onMailerDoc,
      disabled: !(estado === "2" || estado === "4") },
    { tip: "Eliminar", clase: "eliminar", variant: "danger", icon: <BsTrash />, onClick: onDeleteDoc,
      disabled: !(estado === "0" || estado === "5") },
    { tip: "Reprocesar", clase: "reprocesar", icon: <BsArrowRepeat />, onClick: onReprocess,
      disabled: !((estado === "3") || (estado === "1" && currentData.ID_TRANSACCION === "")) },
  ];

  const ejecutar = async (clase, onClick) => {
    setEnCurso(clase);
    try {
      // El estado de carga lo maneja este componente: los manejadores reciben un target vacío
      await onClick({ target: {} }, currentData);
    } finally {
      setEnCurso(null);
    }
  };

  return (
    <div className="nom-acciones">
      {acciones.map(({ tip, clase, variant, icon, onClick, disabled }) => (
        <OverlayTrigger key={clase} placement="top" overlay={<Tooltip>{tip}</Tooltip>}>
          <ActionButton
            square
            variant={variant}
            onClick={() => ejecutar(clase, onClick)}
            disabled={disabled || (enCurso !== null && enCurso !== clase)}
            loading={enCurso === clase}
            aria-label={tip}
          >
            {icon}
          </ActionButton>
        </OverlayTrigger>
      ))}
    </div>
  );
};

export default ActionButtons;



// WEBPACK FOOTER //
// ./src/components/nomina/components/ActionButtons.jsx